export const dayMap = new Map<number, string>([
    [0, 'Lu'],
    [1, 'Ma'],
    [2, 'Me'],
    [3, 'Gi'],
    [4, 'Ve'],
    [5, 'Sa'],
    [6, 'Do'],
])
